import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import GamePage from "@/pages/GamePage";

function App() {
  return (
    <div className="App dark">
      <GamePage />
      <Toaster position="top-center" offset={96} theme="dark" />
    </div>
  );
}

export default App;
